
<kendo-grid [kendoGridBinding]="gridData" [sort]="sort" [sortable]="true"
            [groupable]="true" [resizable]="true" [filter]="filter" filterable="menu" (filterChange)="filterChange($event)"
            (sortChange)="sortChange($event)" style="height: calc(100vh - 200px); min-height: 400px;" [pageSize]="pageSize"
            [pageable]="true">

  <ng-template kendoGridToolbarTemplate position="top">
    <button  (click)="onAddClick()" kendoButton class="btn btn-primary">
      <fa-icon icon="circle-plus"></fa-icon> Add Organisation User </button>
  </ng-template>

  <kendo-grid-column title="Edit" [width]="70">
    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
      <button  (click)="onEditClick(dataItem)" kendoButton class="btn btn-stn-grid">
        <fa-icon icon="edit"></fa-icon>
      </button>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="user" title="User" [width]="200">
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
                         [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="email" title="User Email" [width]="200">
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
                         [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="user_roles_text" title="Roles" [width]="200">
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService" [encoded]="true">
      <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
                         [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column title="Delete" [width]="80">
    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
      <button  (click)="onConfirmDelete(dataItem)" kendoButton class="btn btn-stn-grid">
        <fa-icon icon="trash"></fa-icon>
      </button>
    </ng-template>
  </kendo-grid-column>


  <ng-template kendoPagerTemplate>
    <kendo-pager-info *ngIf="pageSize > 0"></kendo-pager-info>
  </ng-template>

</kendo-grid>

<kendo-dialog-actions>
  <button kendoButton (click)="onCancelAction()" class="btn btn-primary">Close</button>
</kendo-dialog-actions>

